import { dataCompassSolid } from 'dls-icons-data'
import { createIcon } from '../common'

const IconCompassSolid = /*#__PURE__*/createIcon(dataCompassSolid)
export default IconCompassSolid
